export const FORM_INPUT_ENTER_KEY_EVENT = 'FormInputEnterKeyEvent';

export const FORM_INPUT_TYPE = {
  DISABLED: 'disabled',
  TEXTAREA: 'textarea',
};

// Use Snake Case for Key and kebab-case for value.
// Use Alphabetical order.
export const EVENT = {
  INPUT: 'input',
  ON_CANCEL: 'on-cancel',
  ON_NEXT: 'on-next',
  ON_SAVE: 'on-save',
};

export const SCROLL_BEHAVIOUR = {
  SMOOTH: 'smooth',
};

export const SCROLL_BLOCK = {
  CENTER: 'center',
  END: 'end',
  NEAREST: 'nearest',
};

export const FORM_VALIDATION_CLASSES = {
  VALIDATION_ERRORS: '.validation-errors',
};

export const UNDEFINED_CONSTANT = 'undefined';

export const MultiSelectConstants = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  DELETE: 'Delete',
};

export const FORM_SELECT_PRIMARY_VALUE_KEYS = {
  ID: 'id',
  KEY: 'key',
  NAME: 'name',
  VALUE: 'value',
  TEXT: 'text',
};

export const WidgetNotSetFilterKeyValue = {
  NOT_SET_FILTER_KEY: '|ns|',
  NOT_SET_FILTER_VALUE: 'Not Set',
};
